import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Filter from './components/Filter';
import List from './components/List';
import PromotionList from './components/PromotionList';
import RegisterTeaching from './components/RegisterTeaching';
import RewardReport from './components/RewardReport';
import RegisterTime from './components/RegisterTime';
import SheetDetail from './components/SheetDetail';
import ChangeLog from '../Component/ChangeLog';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { queryApprovalUserCachedAsync } from '../../../common/permissionCache';
import SideNav from '../SideNav';
import { saveParams } from '../../../actions/noticeActions';
import RegisterCovTime from './components/RegisterCovTime';

const PAGESIZE = 10;
const adaptData = (datas) => {
    const data = [];
    (datas || []).forEach(o => {
        const { teacherList, rewardList,...rest } = o;
        if ((teacherList || []).length) {
            teacherList.forEach((item, index, array) => {
                const { teacherCode, teacherName, isMain, isArriveFirstEvaluate, firstEvaluateScore, isArriveSecondEvaluate, secondEvaluateScore, isNewIndependent, userTeacherId, newIndependentEvaluateScore, workStatus } = item;
                const { rewardList: reward = [] } = (rewardList || []).find(i => i.currentTeacherCode === teacherCode) || {};
                const rowSpan = index ? 0 : teacherList.length;
                const params = {
                    ...rest,
                    teacherCode: rest.noNeedTeacher == 1 ? 'NA' : teacherCode,
                    teacherName: rest.noNeedTeacher == 1 ? 'NA' : teacherName,
                    teacherWorkStatus: workStatus,
                    isMain,
                    isArriveFirstEvaluate,
                    firstEvaluateScore,
                    isArriveSecondEvaluate,
                    secondEvaluateScore,
                    isNewIndependent,
                    newIndependentEvaluateScore,
                    userTeacherId,
                    rowSpan,
                    hasTeacher: array.every(item => !!item.teacherId)
                };
                reward.forEach((item, index) => {
                    const { rewardType, reportInfoShow, reportFailReasonShow, comment } = item;
                    params[`reportInfo${rewardType}`] = reportInfoShow;
                    params[`reportFailReason${rewardType}`] = reportFailReasonShow;
                    params[`comment${rewardType}`] = comment;
                });
                data.push(params);
            });
        } else {
            data.push({
                ...rest,
                rowSpan: 1,
                hasTeacher: false
            });
        }
    });
    return data;
};

class Management extends Component {
    static childContextTypes = {
        situation: PropTypes.array,
        failureReason: PropTypes.array,
    }

    constructor(props) {
        super(props);
        const { params } = props;
        const { employeeCode } = params || {};
        const searchParams = { employeeCode };
        this.state = {
            searchParams,
            pagination: {
                current: 1,
            },
            loading: false,
            data: [],
            leaveReason: [],
            situation: [],
            failureReason: [],
            position: [],
            current: 0,
            positionNameList: [],
            isAdditionalUser: false,  //是否为后台配置的可以查看该页面的人员
            additionalUserExport: false,  //后台配置的可以查看该页面的人员的导出权限
        };
    }

    componentDidMount() {
        this.queryLeaveReason();
        this.queryRewardDictInfoByType('REPORT_INFO', 'situation');
        this.queryRewardDictInfoByType('REPORT_FAIL_REASON', 'failureReason');
        this.loadData();
        this.queryPositionNameList();
        this.queryApprovalUser();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.current === 0 && this.state.current === 1) {
            this.queryPosition();
        }
    }
    

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ employeeCode: '' });
    }

    queryApprovalUser = () => {
        queryApprovalUserCachedAsync()
        .then(res => {
            const { additionalMenuList } = res;
                let isAdditionalUser = false;
                let additionalUserExport = false;
                additionalMenuList.map(el => {
                    const { menuKey = '', operationKey = '' } = el;
                    if (menuKey == 'TRAINING_MANAGEMENT_LIST') {
                        isAdditionalUser = true;
                        additionalUserExport = operationKey === 'OPERATE_EXPORT';
                    }
                })
                this.setState({
                    isAdditionalUser,
                    additionalUserExport,
                });
        }).catch(err => {
            console.error(err);
        });

    }

    getChildContext = () => {
        const { situation, failureReason } = this.state;
        return {
            situation,
            failureReason,
        };
    }

    queryLeaveReason = () => {
        Fetch.post(API_URL.user.getLeaveConfig)
        .then(res => {
            this.setState({ leaveReason: res.userLeaveReasonList });
        }).catch(err => {
            console.error(err);
        });
    }

    queryRewardDictInfoByType = (rewardType, key) => {
        dictCache.getDict(`TEACH_REWARD_DICT_${rewardType}`, cb => {
            Fetch.post(API_URL.teaching.queryRewardDictInfoByType, {
                rewardType
            }).then(cb).catch(err => {
                console.error(err);
            });
        }, res => {
            this.setState({ [key]: res.data });
        });
    }

    queryPosition = () => {
        Fetch.post(API_URL.teaching.queryAllPromotionPosition)
        .then(res => {
            this.setState({ position: res.data });
        }).catch(err => {
            console.error(err);
        });
    }

    queryPositionNameList = () => {
        Fetch.post(API_URL.teaching.queryPositionNameList,{
            type: 'TEACHER_MANAGER_POSITION',
        }).then(res => {
            this.setState({ positionNameList: res.data });
        })
    }

    loadData = () => {
        const { pagination, searchParams, current: curr } = this.state;
        const { current } = pagination;
        const url = !curr ? API_URL.teaching.queryUserTeacherList : API_URL.teaching.queryPromotionUserTeacherList;
        this.setState({ loading: true });
        Fetch.post(url, {
            offset: current,
            limit: PAGESIZE,
            ...searchParams,
        }).then(res => {
            const { datas, totalCount } = res;
            const data = adaptData(datas);
            pagination.pageSize = data.length;
            pagination.total = Math.floor(totalCount / PAGESIZE) * (data.length) + (totalCount % PAGESIZE);
            this.setState({
                data,
                pagination,
                loading: false,
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    changeCurrent = (current) => {
        this.setState({
            current,
            searchParams: {},
        });
        this.handleSearch();
    }

    handleSearch = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    handleExport = () => {
        const { pagination, searchParams } = this.state;
        ExportUtil.export(searchParams, pagination, API_URL.teaching.exportUserTeacherInfo);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    registerTeaching = (record) => {
        this.registerTeachingRef.show(record);
    }

    registerTime = (record) => {
        this.registerTimeRef.show(record);
    }

    registerCovTime = (record) => {
        this.registerCovTimeRef.show(record);
    }

    showSheet = (type, record) => {
        this.sheetRef.show(type, record);
    }

    rewardReport = (record) => {
        this.rewardReportRef.show(record);
    }

    showChangeLog = (record) => {
        this.changeLogRef.show(record);
    }

    render() {
        const { data, loading, pagination, searchParams, leaveReason, current, position, positionNameList, isAdditionalUser, additionalUserExport } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="management" />
                <div className="main">
                    <Filter
                        current={current}
                        position={position}
                        isAdditionalUser={isAdditionalUser}
                        additionalUserExport={additionalUserExport}
                        leaveReason={leaveReason}
                        searchParams={searchParams}
                        changeCurrent={this.changeCurrent}
                        onSearch={this.handleSearch}
                        onExport={this.handleExport}
                        onChange={this.handleFilterChange}
                        positionNameList={positionNameList}
                    />
                    {
                        current === 0 ?
                            <List
                                data={data}
                                loading={loading}
                                isAdditionalUser={isAdditionalUser}
                                showSheet={this.showSheet}
                                registerTeaching={this.registerTeaching}
                                registerTime={this.registerTime}
                                registerCovTime={this.registerCovTime}
                                rewardReport={this.rewardReport}
                                showChangeLog={this.showChangeLog}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                            />
                        :
                            <PromotionList
                                data={data}
                                loading={loading}
                                showSheet={this.showSheet}
                                rewardReport={this.rewardReport}
                                showChangeLog={this.showChangeLog}
                                pagination={pagination}
                                onChange={this.handleTableChange}
                            />
                    }
                    <SheetDetail ref={el => this.sheetRef = el} />
                    <ChangeLog ref={el => this.changeLogRef = el} />
                    <RegisterTime ref={el => this.registerTimeRef = el} loadData={this.loadData} />
                    <RegisterCovTime ref={el => this.registerCovTimeRef = el} loadData={this.loadData} />
                    <RegisterTeaching ref={el => this.registerTeachingRef = el} loadData={this.loadData} />
                    <RewardReport ref={el => this.rewardReportRef = el} current={current} loadData={this.loadData} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Management);


// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/index.js